export default "__VITE_ASSET__DUYsRL3M__"